import { useState, useEffect, useRef } from 'react'
import { getDynamicLinks } from './getDynamicLinks'

function stringsToBoolean(value) {
  if (typeof value === 'object' && !Array.isArray(value)) {
    return Object.keys(value).reduce((obj, key) => ({ ...obj, [key]: stringsToBoolean(value[key]) }), {})
  }
  if (Array.isArray(value)) {
    return value.map(stringsToBoolean)
  }
  return value === 'true' || value === 'false' ? value === 'true' : value
}

export default function useDynamicNavigation() {
  const [state, setState] = useState({ loading: false })
  const mounted = useRef(true)

  useEffect(() => {
    mounted.current = true
    if (!state.error && !state.loading && !state.navigation) {
      setState({ loading: true })
      getDynamicLinks()
        .then((newNavigation) => {
          if (mounted.current) {
            setState({
              isLoading: false,
              navigation: stringsToBoolean(newNavigation),
            })
          }
        })
        .catch((error) => {
          console.error(error)
          if (mounted.current) {
            setState({ loading: false, error })
          }
        })
    }
    return () => {
      mounted.current = false
    }
  }, [state.error, state.loading, state.navigation])

  return state
}
